<template>
    <div>
        <div class="customerDefinedAlarmConfiguration-title">{{ $t('configuration_management.customized_alarm_config.customizedAlarmConfig') }}</div>
        <div class="customerDefinedAlarmConfiguration-top">
            <customer-defined-alarm-configuration-search></customer-defined-alarm-configuration-search>
        </div>
        <table-customer-defined-alarm-configuration></table-customer-defined-alarm-configuration>
    </div>
</template>

<script>
    import CustomerDefinedAlarmConfigurationSearch from '../customer_defined_alarm_configuration/CustomerDefinedAlarmConfigurationSearch'
    import TableCustomerDefinedAlarmConfiguration from '../customer_defined_alarm_configuration/TableCustomerDefinedAlarmConfiguration'

    export default {
        name: 'CustomerDefinedAlarmConfiguration',
        components: {
            CustomerDefinedAlarmConfigurationSearch,
            TableCustomerDefinedAlarmConfiguration
        }
    }
</script>

<style scoped>
    .customerDefinedAlarmConfiguration-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .customerDefinedAlarmConfiguration-top
    {
        width: 100%;
        height: 53px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/customer_defined_alarm_configuration/CustomerDefinedAlarmConfiguration.vue